import * as React from 'react';
import { BaSeInput, InputProps } from '../../input/text/input';
import { BaSeTheme } from '../../../theme';
import { BaSeList, ListType } from '../list-icon/list-icon';
import { ContainerInputList, WrapperInputList } from './input-list-styled';

interface InputListType extends InputProps {
  sizeInput?: 'medium' | 'small' | 'big';
  nameButton: string;
  valueButton: string;
  buttonAction: (value: string) => void;
  typeButton: 'base-icon' | 'base-button' | 'base-shape-button';
  listItems: ListType;
  expandToMaxWidth?: boolean;
}

export const BaSeInputList: React.FC<InputListType> = ({
  width = '100%',
  listItems = {
    valuesList: [],
    direction: 'column',
    listActions: [
      {
        size: 'medium',
        sizeIcon: 'medium',
        ActionisDisabled: false,
        nameIcon: 'trash-alt',
        color: BaSeTheme.colors.institucionais.azulSebrae36,
        listAction: () => {},
      },
    ],
  },
  isDisabled = false,
  nameButton = 'plus',
  valueButton = 'Adicionar',
  sizeInput = 'medium',
  inputMode = 'text',
  typeInput = 'text',
  typeButton = 'base-button',
  placeholder = '',
  complement = '',
  value = '',
  label = '',
  subLabel = '',
  expandToMaxWidth = false,
  maxLength,
  buttonAction = () => {},
  // tslint:disable-next-line: trailing-comma
  ...rest
}) => {
  const [newValue, setNewValue] = React.useState(value);
  const inputAction = () => {
    buttonAction(newValue);
    setNewValue('');
  };
  return (
    <ContainerInputList width={width}>
      <WrapperInputList isFlex={!expandToMaxWidth}>
        <BaSeInput
          {...rest}
          value={newValue}
          onChange={(changeValue) => setNewValue(changeValue)}
          label={label}
          size={sizeInput}
          subLabel={subLabel}
          typeInput={typeInput}
          inputMode={inputMode}
          complement={complement}
          width={width}
          isDisabled={isDisabled}
          maxLength={maxLength}
          placeholder={placeholder}
          iconButton={{
            typeButton,
            name: nameButton,
            action: inputAction,
            type: 'primary',
            value: valueButton,
            color: BaSeTheme.colors.institucionais.azulSebrae36,
          }}
        />
      </WrapperInputList>
      <BaSeList {...listItems} />
    </ContainerInputList>
  );
};

BaSeInputList.displayName = 'BaSeInputList';
